<template>
	
	<div>
		
		<Header :utilityNav="header.utilityNav" :siteNavigation="header.siteNavigation"></Header>
		
		<div class="container">
			
			<Breadcrumbs v-if="breadcrumbs" :breadcrumbs="breadcrumbs"></Breadcrumbs>
			
			<div class="columns row">

				<div class="main col-lg-8 order-lg-last">
					<div class="video-wrapper">
						<iframe src="https://www.youtube.com/embed/kemivUKb4f4"></iframe>
					</div>
					<div class="commissioner-info">
						<h1 class="name">Marvin S. Arrington Jr.</h1>
						<span class="district">District 5</span>
						<span class="details">Term: Jan. 1, 2019 until Dec. 31, 2022</span>
						<a href="#">
							<span>
								Latest News Release
							</span>
						</a>
					</div>
					<div class="detail-section">
						<h2 class="intro-text">Intro Text</h2>
						<p>
							Quick win emoji run whistler smart alexa gif okemo works on my local internet outage audit laptop Boston. App zuma data run laptop rock & roll quick wins nerf war out of scope fireside chat run out of scope. Drive Boston the nest creative Robin Reviews super simple quick wins hotlist accountability frontier. Motown quick win ping pong dragons New York integrity migration. La Croix Visual Studio solutions hyde focus beer mos eisley global serves serve quick win agile solutions. The cliffs hyde global wi-fi platforms whistler Atlanta. Board games sipping time La Croix design zune akward teenage stage serve agency of the future the dungeon integrity engineering serve Dallas. Science fair whistler ping pong frontier. Cold brew abbey road integrity nerf war. Skype serves crawl Atlanta Denver rubber duck Episerver flash Skype low hanging fruit el porto.
						</p>
						<img src="https://picsum.photos/600/400?12" alt="Alternate Text" />
						<p>
							Lift and shift learning laptop copper sarvis. Work Denver pretzels hunky dory fox La Croix analytics. The cliffs design shopping digital rainbows gather inspire Jaipur insight matrix brand. Episerver parter Sharepoint zuma inspire experts audit the lair are you on mute san onofre brand. The port ping pong Los Angeles testing loon Teams hunky dory brand cheese and whine the lair stowe Sharepoint hardware. Tubing experts lift and shift starfish collaboration technology profitability mobile bowling in the work network. Meenie shopping collaboration stowe Slack gif people Coca-Cola. War room cathedral baywatch out of scope city palace the blindside innovation mvp emoji hoteling passion ping pong coffee. You're not sharing your screen super simple tubing alexa fireside chat network pourcast focus. Zuma laptop analytics virtual board games.
						</p>
						<p>
							Alexa intrapreneurship moe expertise crawl drive engineering zune New York sarvis crawl san onofre. Starfish creative the nest Skype digital mos eisley engineering pride beer platforms virtual pizza. Episerver work cloud in the work lift and shift miney Boston platforms punchline whistler. Digital Starbucks interface need moar coffee matrix meenie. Content wi-fi Oakland wi-fi i-frame management. Thread bowling are you on mute amer mvp content motown organization dragons desktop fox hawa mahal. Management internet outage hunky dory Atlanta mobile audit accountability board games stranger things walk. Pretzels Coca-Cola insight sarves expertise Los Angeles ping pong. Productivity shopping hardware lord of the mini coop app laptop emoji lord of the mini coop. Studio one Boston crawl digital beer fox stowe ctrl alt delete sunapee Starbucks.
						</p>
						<blockquote>
							Excellence powershell all the things wi-fi hawa mahal the lair. The blindside run dukes of hazard meetings productivity Raizlabs Sitecore.
						</blockquote>
						<h5 class="intro-text">Mid Title</h5>
						<p>
							Quick win emoji run whistler smart alexa gif okemo works on my local internet outage audit laptop Boston. App zuma data run laptop rock & roll quick wins nerf war out of scope fireside chat run out of scope. Drive Boston the nest creative Robin Reviews super simple quick wins hotlist accountability frontier. Motown quick win ping pong dragons New York integrity migration. La Croix Visual Studio solutions hyde focus beer mos eisley global serves serve quick win agile solutions. The cliffs hyde global wi-fi platforms whistler Atlanta. Board games sipping time La Croix design zune akward teenage stage serve agency of the future the dungeon integrity engineering serve Dallas. Science fair whistler ping pong frontier. Cold brew abbey road integrity nerf war. Skype serves crawl Atlanta Denver rubber duck Episerver flash Skype low hanging fruit el porto.
						</p>
						<p>
							Lift and shift learning laptop copper sarvis. Work Denver pretzels hunky dory fox La Croix analytics. The cliffs design shopping digital rainbows gather inspire Jaipur insight matrix brand. Episerver parter Sharepoint zuma inspire experts audit the lair are you on mute san onofre brand. The port ping pong Los Angeles testing loon Teams hunky dory brand cheese and whine the lair stowe Sharepoint hardware. Tubing experts lift and shift starfish collaboration technology profitability mobile bowling in the work network. Meenie shopping collaboration stowe Slack gif people Coca-Cola. War room cathedral baywatch out of scope city palace the blindside innovation mvp emoji hoteling passion ping pong coffee. You're not sharing your screen super simple tubing alexa fireside chat network pourcast focus. Zuma laptop analytics virtual board games.
						</p>
						<p>
							Alexa intrapreneurship moe expertise crawl drive engineering zune New York sarvis crawl san onofre. Starfish creative the nest Skype digital mos eisley engineering pride beer platforms virtual pizza. Episerver work cloud in the work lift and shift miney Boston platforms punchline whistler. Digital Starbucks interface need moar coffee matrix meenie. Content wi-fi Oakland wi-fi i-frame management. Thread bowling are you on mute amer mvp content motown organization dragons desktop fox hawa mahal. Management internet outage hunky dory Atlanta mobile audit accountability board games stranger things walk. Pretzels Coca-Cola insight sarves expertise Los Angeles ping pong. Productivity shopping hardware lord of the mini coop app laptop emoji lord of the mini coop. Studio one Boston crawl digital beer fox stowe ctrl alt delete sunapee Starbucks.
						</p>
					</div>
				</div>

				<div class="sidebar col-lg-4 order-lg-first">

					<div class="people-callout">
						<div class="portrait">
							<div class="img"></div>
						</div>
						<div class="details">
							<h2 class="h3">Greetings from commissioner arrington jr.</h2>
							<p>
								Drive war room el porto Raizlabs mobile beer sarvis hunky dory. Akward teenage stage hyde chunky staffing technology spark palm pilot management my space shopping. Content Robin Reviews bowling brand Visual Studio integrity unicorn culture hawa mahal digital coffee. Dallas dickory Oakland snack time headphones solutions. Okemo audit moe video games. Flash culture tubing dragons testing accountability profitability the lair. Pride crawl hotlist culture. Crawl rock & roll hardware Coca-Cola. Brand i-frame augmented Raizlabs Dallas focus interface. Okemo dickory experts ping pong Raizlabs okemo bowling.
							</p>
						</div>
					</div>
					<div :key="card.id" v-for="card in contactCards">
						<ContactCard :contactCard="card"></ContactCard>
					</div>
					<div class="basic-callout">
						<div class="title-img">
							<img src="https://picsum.photos/500/300?15" alt="Alternate Text" />
							<!--<div class="overlay">
					<a href="#">Link number 1</a>
				</div>-->
						</div>
						<div class="callout-text">
							<h2 class="title h3">
								Cities in District 5
							</h2>
							<p class="detail">
								This is more detailed text.  It could be several sentences and go on for awhile.
							</p>
							<!--<a href="#">Link number 2</a>-->
						</div>
					</div>
					<div class="link-list-callout">
						<h2 class="title h3">
							Cities in District 5
						</h2>
						<div class="title-img">
							<img src="https://picsum.photos/500/300?10" alt="Alternate Text" />
						</div>
						<div class="callout-text">
							<p class="detail">
								This block will need to be an RTE to give the content author the ability to make text, links, etc.
								<a href="#">This could be a link</a>
								<ul>
									<li>list item1</li>
									<li><a href="#">list item as link</a></li>
									<li>list item3</li>
								</ul>
								<ol>
									<li>list item1</li>
									<li>list item2</li>
									<li>list item3</li>
								</ol>
							</p>
						</div>
					</div>
				</div>

			</div>
		</div>
		
		<Footer :contact="footer.contact" :nav="footer.nav" :social="footer.social" :legal="footer.legal"></Footer>

	</div>
	
	
</template>

<script>
	
	import Header from '../components/Header/Header.vue';
    import Breadcrumbs from '../components/Global/Breadcrumbs.vue';
	import ContactCard from '../components/ContactCard/ContactCard.vue';
	import Footer from '../components/Footer/Footer.vue';

	import axios from 'axios';
	
	export default {
		name: 'CommissionerLandingPage',
		
		components: {
			Header,
            Breadcrumbs,
			ContactCard,
			Footer
		},
		
		data() {
			return {
                breadcrumbs: [],
				contactCards: [],
				
				header: {
					utilityNav: {},
					siteNavigation: {}
				},
				footer: {
					contact: {},
					nav: [],
					social: [],
					legal: ""
				}
			}
		},
		
		mounted: function() {
			
			/* eslint-disable no-console */
			let self = this;
			
			let header = 'SampleData/HeaderData.json';
			axios.get(header).then(function(response) {
				
				self.header.utilityNav = response.data.utilityNav;
				self.header.siteNavigation = response.data.siteNavigation;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let endpointID = this.$el.parentElement.getAttribute('data-endpoint-id');
			if (endpointID) {
				
				let endpoint = 'SampleData/' + endpointID + '.json';
	
				axios.get(endpoint).then(function(response) {
					
                    self.breadcrumbs = response.data.breadcrumbs;
                    self.contactCards = response.data.cards;
				})
				.catch(function (error) {
					console.log(error);
				});
			}
			
			let footer = 'SampleData/FooterData.json';
			axios.get(footer).then(function(response) {
				
				self.footer.contact = response.data.contact;
				self.footer.nav = response.data.nav;
				self.footer.social = response.data.social;
				self.footer.legal = response.data.legal;
			})
			.catch(function (error) {
				console.log(error);
			});
		}
	}
	
</script>